import PoolDevice from "./base";
import { PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import { DeviceTypes } from "../../config/documents/HardwareConfig";


export default class PoolDeviceFillSwitch extends PoolDevice implements PoolDeviceInterface {
    static minAutoFilterVersion = 5;
    static DeviceType = DeviceTypes.FILLSWITCH;
    static Icon = "water-pump";
    static PickerTitle = Locale.gettext("Fill Switch");
}


export enum PoolsideDaemonDeviceStateNames {
    State = "State"
}

    
